import {cart} from '@/app/js/cart'
import {wishlist} from '@/app/js/wishlist'
import {Debounce} from '@/app/js/helpers/debounced'
import {openCartPopup} from '@/app/js/cart-popup'

const debounce = new Debounce

function handleAddProductToCart(productEl, addBtnEl, quantityEl, optionEls) {
  if (!addBtnEl) {
    return
  }

  const {cartPage} = addBtnEl.dataset

  addBtnEl.addEventListener('click', () => {
    let option = {}
    for (const optionEl of optionEls) {
      if (optionEl.checked) {
        option[optionEl.name] = optionEl.value
      }
    }
    const {id: productId} = productEl.dataset
    cart.add(productId, quantityEl?.value || 1, option).then(() => openCartPopup(productId))
    window.location.href = cartPage
  })
}

function handleAddAndCheckoutProductToCart(productEl, addBtnEl, quantityEl) {
  if (!addBtnEl) {
    return
  }

  addBtnEl.addEventListener('click', () => {
    cart.add(productEl.dataset.id, quantityEl?.value || 1)
      .then(() => {
        window.location.assign('/index.php?route=checkout/checkout')
      })
  })
}

export function handleProductCartQuantity(productEl, isReload = true) {
  const {cartId} = productEl.dataset
  const cartQuantityEl = productEl.querySelector('.js-product-cart-quantity')
  const cartChangeButtons = productEl.querySelectorAll('.js-product-change-quantity')

  if (!cartQuantityEl) {
    return
  }

  const firstValue = cartQuantityEl.value

  for (const btn of cartChangeButtons) {
    btn.addEventListener('click', () => {
      const inputValue = Number(cartQuantityEl.value)
      const {type} = btn.dataset

      if (type === 'increase') {
        cartQuantityEl.value = inputValue + 1
      } else if (type === 'decrease' && inputValue > 1) {
        cartQuantityEl.value = inputValue - 1
      }

      cartQuantityEl.dispatchEvent(new Event('change'))
    })
  }


  cartQuantityEl.addEventListener('change', () => {
    debounce.exec(() => {
      if (cartQuantityEl.value === firstValue) {
        return
      }

      cart.update(cartId, cartQuantityEl.value)
        .then(() => {
          if (isReload) {
            window.location.reload()
          }
        })
    })
  })
}

export function initProduct(productEl) {
  const {id, cartId} = productEl.dataset

  handleAddProductToCart(
    productEl,
    productEl.querySelector('.js-product-add'),
    productEl.querySelector('.js-product-quantity'),
    productEl.querySelectorAll('.js-product-option')
  )

  handleAddAndCheckoutProductToCart(
    productEl,
    productEl.querySelector('.js-product-add-and-checkout'),
    productEl.querySelector('.js-product-quantity')
  )

  productEl.querySelector('.js-product-delete')?.addEventListener('click', () => {
    cart.delete(cartId)
      .then(() => {
        window.location.reload()
      })
  })

  handleProductCartQuantity(productEl)

  productEl.querySelector('.js-product-wish')?.addEventListener('click', () => {
    wishlist.add(id)
  })
}

export function initProducts() {
  document.querySelectorAll('.js-product').forEach(initProduct)
}
